export const langConversionHelper = {
  languageList,
  findLanguage,
  findLanguageAbbrev,
  getLanguageDisplayName,
  dayConversion,
  dayAbbrevConversion,
  monthConversion,
  monthAbbrevConversion,
  engineClassList,
  displayHearAboutLists,
};

const languages = [
  {
    langAbbrev: "en-US" || "en-AU" || "en-GB" || "en",
    nativeName: "In English",
    languageId: 1,
    displayName: "English",
    displayNameEs: "Inglés",
  },
  {
    langAbbrev: "es",
    nativeName: "En Español",
    languageId: 2,
    displayName: "Español",
    displayNameEs: "Español",
  },
  {
    langAbbrev: "sv",
    nativeName: "Zweeds",
    languageId: 3,
    displayName: "Zweeds",
    displayNameEs: "Zweeds",
  },
  {
    langAbbrev: "fr",
    nativeName: "Français",
    languageId: 4,
    displayName: "Français",
    displayNameEs: "Français",
  },
  {
    langAbbrev: "fi",
    nativeName: "Suomi",
    languageId: 5,
    displayName: "Suomi",
    displayNameEs: "Suomi",
  },
  {
    langAbbrev: "pt",
    nativeName: "Português",
    languageId: 6,
    displayName: "Português",
    displayNameEs: "Português",
  },
  {
    langAbbrev: "de",
    nativeName: "Deutsch",
    languageId: 7,
    displayName: "Deutsch",
    displayNameEs: "Deutsch",
  },
  {
    langAbbrev: "nl",
    nativeName: "Nederlands",
    languageId: 8,
    displayName: "Nederlands",
    displayNameEs: "Nederlands",
  },
  {
    langAbbrev: "it",
    nativeName: "In Italiano",
    languageId: 9,
    displayName: "Italiano",
    displayNameEs: "Italiano",
  },
  {
    langAbbrev: "no",
    nativeName: "Norsk",
    languageId: 10,
    displayName: "Norsk",
    displayNameEs: "Norsk",
  },
  {
    langAbbrev: "pl",
    nativeName: "Polski",
    languageId: 11,
    displayName: "Polski",
    displayNameEs: "Polski",
  },
  {
    langAbbrev: "cs",
    nativeName: "Čeština",
    languageId: 12,
    displayName: "Čeština",
    displayNameEs: "Čeština",
  },
  {
    langAbbrev: "fr-CA",
    nativeName: "Français Canadien",
    languageId: 13,
    displayName: "Français Canadien",
    displayNameEs: "Français Canadien",
  },
];

// const languages = [
//   {
//     langAbbrev: "enUS",
//     nativeName: "In English",
//     languageID: 1,
//     displayName: "English",
//     displayNameEs: "Inglés",
//   },
//   {
//     langAbbrev: "es",
//     nativeName: "En Español",
//     languageID: 2,
//     displayName: "Español",
//     displayNameEs: "Español",
//   },
//   {
//     langAbbrev: "it",
//     nativeName: "In Italiano",
//     languageID: 3,
//     displayName: "Italiano",
//     displayNameEs: "Italiano",
//   },
// ];
const daysOfTheWeekTranslation = [
  { enDay: "Sunday", es: "domingo" },
  { enDay: "Monday", es: "lunes" },
  { enDay: "Tuesday", es: "martes" },
  { enDay: "Wednesday", es: "miércoles" },
  { enDay: "Thursday", es: "jueves" },
  { enDay: "Friday", es: "viernes" },
  { enDay: "Saturday", es: "sábado" },
];
const monthsOfYearTranslation = [
  { enMonth: "January", es: "enero" },
  { enMonth: "February", es: "febrero" },
  { enMonth: "March", es: "marcha" },
  { enMonth: "April", es: "abril" },
  { enMonth: "May", es: "mayo" },
  { enMonth: "June", es: "junio" },
  { enMonth: "July", es: "julio" },
  { enMonth: "August", es: "agosto" },
  { enMonth: "September", es: "septiembre" },
  { enMonth: "October", es: "octubre" },
  { enMonth: "November", es: "noviembre" },
  { enMonth: "December", es: "diciembre" },
];
const daysOfTheWeekAbbrevTranslation = [
  { enDay: "Sun", es: "dom" },
  { enDay: "Mon", es: "lun" },
  { enDay: "Tue", es: "mar" },
  { enDay: "Wed", es: "mié" },
  { enDay: "Thu", es: "jue" },
  { enDay: "Fri", es: "vie" },
  { enDay: "Sat", es: "sáb" },
];
const monthAbbrevTranslation = [
  { enMonth: "Jan", es: "ene" },
  { enMonth: "Feb", es: "feb" },
  { enMonth: "Mar", es: "mar" },
  { enMonth: "Apr", es: "abr" },
  { enMonth: "May", es: "may" },
  { enMonth: "Jun", es: "jun" },
  { enMonth: "Jul", es: "jul" },
  { enMonth: "Aug", es: "ago" },
  { enMonth: "Sep", es: "sep" },
  { enMonth: "Oct", es: "oct" },
  { enMonth: "Nov", es: "nov" },
  { enMonth: "Dec", es: "dic" },
];

const engineClass = [
  {
    en: "Gasoline or Diesel",
    es: "Gasolina o Diésel",
    it: "Benzina o Diesel",
    code: 1,
  },
  {
    en: "Hybrid",
    es: "Híbrido",
    it: "Ibrido",
    code: 2,
  },
  {
    en: "Electric",
    es: "Eléctrico",
    it: "Elettrico",
    code: 3,
  },
  {
    en: "Natural Gas",
    es: "Gas Natural",
    it: "Gas naturale",
    code: 4,
  },
];

const hearAboutLists = [
  {
    code: 1,
    en: "Attorney",
    es: "Abogado",
  },
  {
    code: 2,
    en: "Court",
    es: "Tribunal",
  },
  {
    code: 3,
    en: "Driving School",
    es: "Escuela de Manejo",
  },
  {
    code: 4,
    en: "Enrollment Code",
    es: "Código de Inscripción",
  },
  {
    code: 5,
    en: "Friend",
    es: "Amigo(a)",
  },
  {
    code: 6,
    en: "Other",
    es: "Otro",
  },

  {
    code: 7,
    en: "Service Center",
    es: "Centro de Servicio",
  },
  {
    code: 8,
    en: "Treatment Center",
    es: "Centro de Tratamiento",
  },
];

//Language Options
function languageList() {
  return languages;
}
function findLanguage(languageID) {
  let obj = languages.find(
    (x) => (x.languageId ?? x.languageID) === languageID,
  );

  if (obj === undefined) return "";
  else {
    if (
      obj.displayName !== null &&
      obj.displayName != "" &&
      obj.displayName !== undefined
    )
      return obj.displayName;
    else return "";
  }
}
function findLanguageAbbrev(languageID) {
  let obj = languages.find(
    (x) => (x.languageId ?? x.languageID) === languageID,
  );
  if (obj === undefined) return "en";
  else {
    if (
      obj.langAbbrev !== null &&
      obj.langAbbrev != "" &&
      obj.langAbbrev !== undefined
    )
      return obj.langAbbrev;
    else return "en";
  }
}

function getLanguageDisplayName(languageID, uiLang) {
  let obj = languages.find((x) => (x.languageId ?? x.languageID) == languageID);
  if (obj === undefined) return "";

  const normalizedLang = (uiLang || "").toLowerCase();
  if (normalizedLang.startsWith("es")) {
    if (
      obj.displayNameEs !== null &&
      obj.displayNameEs != "" &&
      obj.displayNameEs !== undefined
    )
      return obj.displayNameEs;
  }
  if (
    obj.displayName !== null &&
    obj.displayName != "" &&
    obj.displayName !== undefined
  )
    return obj.displayName;
  return "";
}

function engineClassList(languageId) {
  let engineClassArray = engineClass.map((engClass) => ({
    label: engClass[languageId] || engClass.en,
    code: engClass.code,
  }));
  engineClassArray.sort((a, b) => a.code - b.code);
  return engineClassArray;
}

//If for any reason the conversion can't happen return the English version
function dayConversion(day, transLang) {
  let obj = daysOfTheWeekTranslation.find((x) => x.enDay === day);
  return propertyCheck(obj, transLang, day);
}
function dayAbbrevConversion(day, transLang) {
  let obj = daysOfTheWeekAbbrevTranslation.find((x) => x.enDay === day);
  return propertyCheck(obj, transLang, day);
}
function monthConversion(month, transLang) {
  let obj = monthsOfYearTranslation.find((x) => x.enMonth === month);
  return propertyCheck(obj, transLang, month);
}
function monthAbbrevConversion(month, transLang) {
  let obj = monthAbbrevTranslation.find((x) => x.enMonth === month);
  return propertyCheck(obj, transLang, month);
}

// Property Helper to ensure key exists & the ensure value is not null, empty, or undefined
function propertyCheck(obj, key, original) {
  if (obj === undefined || !(key in obj)) return original;
  else {
    if (obj[key] !== null && obj[key] != "" && obj[key] !== undefined)
      return obj[key];
    else return original;
  }
}

function displayHearAboutLists(description, language) {
  const hearAbout = hearAboutLists?.find((x) => x?.en === description);

  const selectedLanguage = language === "es" ? "es" : "en";

  return hearAbout ? hearAbout[selectedLanguage] : description;
}
